import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            用户好评
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            来自真实用户的观影反馈，品质由口碑见证
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {commentsData.map((item) => (
            <div
              key={item.id}
              className="p-6 bg-background-50 rounded-lg border border-background-200/60"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900">
                    {item.name}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${
                        i < item.rating
                          ? 'ri-star-fill text-accent-500'
                          : 'ri-star-line text-foreground-300'
                      }`}
                    ></i>
                  ))}
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}